import { useState, useEffect, useCallback } from 'react';
import { userService } from 'api/services/users';

export const useUserSearch = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [role, setRole] = useState('');

  useEffect(() => {
    const trimmedQuery = query.trim();

    // Reset if query is empty
    if (!trimmedQuery) {
      setResults([]);
      setLoading(false);
      setError('');
      return;
    }

    // Validate minimum query length (must match backend validation)
    if (trimmedQuery.length < 2) {
      setResults([]);
      setLoading(false);
      setError('Please enter at least 2 characters to search');
      return;
    }

    let isCancelled = false;
    const handler = setTimeout(async () => {
      setLoading(true);
      setError('');
      try {
        const data = await userService.searchUsers(
          trimmedQuery,
          'name',
          role || undefined
        );
        if (!isCancelled) {
          setResults(data?.users || data || []);
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err?.error || err?.message || 'Failed to search users');
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    }, 500); // Increased from 300ms to 500ms to reduce API calls

    return () => {
      isCancelled = true;
      clearTimeout(handler);
    };
  }, [query, role]);

  const handleChange = useCallback((value) => {
    setQuery(value);
  }, []);

  return {
    query,
    setQuery: handleChange,
    results,
    loading,
    error,
    role,
    setRole,
  };
};
